import { useCallback, useEffect, useState } from 'react';
export function useApi(fetcher, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const run = useCallback(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    fetcher()
      .then((data) => alive && setState({ data, loading: false, error: null }))
      .catch((e) => alive && setState({ data: null, loading: false, error: e.message || 'Lỗi tải dữ liệu' }));
    return () => { alive = false; };
    // eslint-disable-next-line
  }, deps);
  useEffect(run, [run]);
  return { ...state, reload: run };
}
